import { SignIn } from "@clerk/react";
import { Center } from "@mantine/core";
import { Footer } from "../components/Footer";

export function LoginPage() {
  return (
    <Center mih="100vh" bg="gray.0" style={{ flexDirection: "column" }}>
      <SignIn routing="path" path="/login" fallbackRedirectUrl="/" withSignUp />
      <Footer />
    </Center>
  );
}
